module.exports = __webpack_public_path__ + "img/product.f30fc114.svg";